import { createColumnHelper } from '@tanstack/react-table';
import { IconRounded } from 'src/components/IconRounded/IconRounded';
import { maxDraft, removeDraft } from 'src/app/slices/dockSlice';
import styles from '../pages/DashboardDraftsScreen/DashboardDraftsScreen.module.scss';

const columnHelper = createColumnHelper<any>();
export const draftsTableColumns = (dispatch: any) => [
  columnHelper.accessor('type', {
    header: () => <>Type</>,
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor('windowStatus', {
    header: () => <>Status</>,
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor('data.text', {
    header: () => <>Texto</>,
    cell: (info) => (
      <div className={styles.table_textField}>{info.getValue() || ''}</div>
    ),
  }),
  columnHelper.accessor('data.id', {
    header: () => <>Acciónes</>,
    cell: (info) => (
      <div className={styles.actions_container}>
        <IconRounded
          size={40}
          icon='edit'
          iconColor='#3465b8'
          onClick={() => {
            dispatch(maxDraft({ id: info.getValue() }));
          }}
        />

        <IconRounded
          size={40}
          icon='trash'
          iconColor='#3465b8'
          onClick={() => {
            dispatch(removeDraft({ id: info.getValue() }));
          }}
        />
      </div>
    ),
  }),
];
